import { DateTime } from 'luxon';

// A function that takes time as a string and some specifications, and returns luxon object.
// PARAMETERS:
// timeStr: ISO 8601 string
// format: 'onlyTime' | 'three-hours' | ... c.f. bellow
// language: for luxon localization
// hourCycle: 24 h / 12 h clock: 'h12' | 'h23'
// offset: offset in minutes for handling the time zones
export const formatTime = (timeStr, format='DATETIME_SHORT', language='en', hourCycle='h12', offset=0) => {
  let formatOptions = {};
  switch (format) {
    case 'onlyTime':
    case 'three-hours':         // timeRange.name
      formatOptions =  DateTime.TIME_SIMPLE;
      break;
    case 'timeDay':
    case 'one-day':               // timeRange.name
    case 'one-week':              // timeRange.name
    case 'one-month':             // timeRange.name
    case 'six-months':            // timeRange.name
    case 'one-year':              // timeRange.name
    case 'from-reference-time':   // timeRange.name
    case 'from-activation-time':  // timeRange.name
    case 'custom-timerange':    // timeRange.name
      const {year, ...preformatingWihtOutYear} = DateTime.DATETIME_SHORT;
      formatOptions = {...preformatingWihtOutYear,  weekday: 'short'};
      break;
    case 'onlyDate':
    //case 'one-month':           // timeRange.name
      formatOptions = DateTime.DATE_SHORT;
      break;
    default:
      formatOptions = DateTime[format];
      break;
  }

  return DateTime
    .fromISO(timeStr)
    .toUTC(offset)
    .setLocale(language)
    .toLocaleString({...formatOptions, hourCycle});
}
